export default "__VITE_ASSET__DEwPwcPW__"